import { createApp, h } from "vue";
import FabricToShowImage from "@/components/other/fabricToShowImage.vue";

export default {
  beforeMount(el, binding) {
    // Store the initial HTML content for comparison
    const html = binding.value;
    el.__prevContent = html;
    divAppendChild(el, html);
  },
  updated(el, binding) {
    const html = binding.value;
    // Check if content has changed
    if (el.__prevContent !== html) {
      el.__prevContent = html;
      divAppendChild(el, html);
    }
  },
};

function divAppendChild(el, html) {
  const containsQlImage =
    html && html.includes("ql-image") && html.includes("formatinfo");
  if (containsQlImage) {
    const vnode = htmlToVNode(html);
    const app = createApp({
      render() {
        return vnode;
      },
    });
    const tempDiv = document.createElement("div");
    const vm = app.mount(tempDiv);
    // Clear the existing content of the target element and append the new content
    el.innerHTML = "";
    el.appendChild(vm.$el);
  } else {
    el.innerHTML = html;
  }
}

function htmlToVNode(html) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  function convertElement(element) {
    const tag = element.tagName.toLowerCase();
    const children = Array.from(element.childNodes)
      .map((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          return convertElement(node);
        } else if (node.nodeType === Node.TEXT_NODE) {
          return node.textContent;
        }
      })
      .filter(Boolean);
    const props = {};
    Array.from(element.attributes).forEach((attr) => {
      props[attr.name] = attr.value;
    });
    // 如果标签是 img，则替换为 FabricToShowImage 组件
    if (tag === "img") {
      const src = props.src || "";
      const formatInfo = props.formatinfo
        ? JSON.parse(props.formatinfo.replace(/'/g, '"'))
        : "";
      const canClick = props.canclick === "true" ? true : false;
      return h(
        FabricToShowImage,
        { fileUrl: src, formatInfo, canClick },
        children
      );
    }
    return h(tag, props, children);
  }

  return convertElement(tempDiv.firstChild);
}
